import {createAxios} from './axios';
import {BASE_API_URL} from "./config";

const zoomApi = createAxios({
    baseURL: BASE_API_URL + '/appointments'
});

export const postTelehealthAppointment = (appointmentId) => {
    return zoomApi.get(`/${appointmentId}/zoom-meeting/join-url`);
};